/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState,useEffect } from 'react';
import { Form, Table, ConfigProvider,Tag,Space} from 'antd';
import { hnrequest } from '@/utils'
import './index.scss'
import zhCN from 'antd/locale/zh_CN';





const Bxf = () => {
  
  
   const [bangm, setbangm] = useState([]);
  useEffect(() => {
    async function getau() {
      const res = await hnrequest.post('/p_xflist')
       setbangm(res.rescode)
    }
  
    getau()
  
  }, [])
  

 



 
 const columns = [
  
  {
    title: '订单编号',
    dataIndex: 'ddno',
    key: 'ddno',
  },
  {
    title: '金额',
    dataIndex: 'bd_je',
    key: 'bd_je',
  },
  {
    title: '支付方式',
    dataIndex: 'p_w',
    key: 'p_w',
  },
  {
    title: '支付时间',
    dataIndex: 'dtime',
    key: 'dtime',
  }
  ,{
    title: '开票状态',
    dataIndex: 'kpzt',
    key: 'kpzt',
    render: (_, record) => (
      <Space size="middle">
        {record.kpzt === "N" && <Tag color="green" >待开</Tag>}
        {record.kpzt === "Y" && <Tag color="volcano" >已开</Tag>}
       
      </Space>
    ),
  }
];
  

  

 









  const [form] = Form.useForm();
  return (<ConfigProvider locale={zhCN} >

    <div 
    // style={containerStyle} 
    >

      <Form form={form} component={false}>

      <Table size="small" columns={columns} dataSource={bangm} rowKey="ddno"/>

      </Form>
      开票功能待优化


      
    </div>

    
  </ConfigProvider>

  );
};
export default Bxf;